import styled from "styled-components";
import {dark} from "../../common/theme";

const BasicCardTag = styled.div`
  white-space: nowrap;
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 6px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
`;
export const CustomCardTag = styled(BasicCardTag)`
  color: ${props => dark.dark_200};
  background-color: ${props => dark.white_200};
  border: 1px solid ${props => dark.black_border_color};
`;

export const ColoredCustomCardTag = styled(BasicCardTag)`
  color: ${props => props.theme.color.dark_200};
  background-color: ${props => props.theme.color.white_200};
  border: 1px solid ${props => props.theme.color.black_border_color};
`;


export const ServerTypeCardTag = styled(BasicCardTag)`
  color: ${props => dark.dark_100};
  background-color: ${props => dark.white_200};
  border: 1px solid ${props => dark.black_border_color};

`;